const DEFAULT_SITE_ORIGIN = 'https://app.ladobom.com';

export const toAbsoluteUrl = (path: string): string => {
  const normalizedPath = String(path || '').trim();
  if (!normalizedPath) return '';

  if (/^https?:\/\//i.test(normalizedPath)) {
    return normalizedPath;
  }

  const origin =
    typeof window !== 'undefined' && window.location.origin
      ? window.location.origin
      : DEFAULT_SITE_ORIGIN;

  return new URL(normalizedPath, origin).toString();
};
